// extracted by mini-css-extract-plugin
var _1 = "MonthYearSpinInput-moduleMonthYearSpinInput__ToJal NavArrows-moduleNavArrows__ZbT73";
export { _1 as "MonthYearSpinInput" }
